import { Box, Button, Code, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { SitesAutoComplete } from "../../autoComplete/site/sites-autoComplete";

export function RoutingMoldForm(params: {
  name: string;
  onSubmit?: (values: any) => void;
}) {
  const { name, onSubmit } = params;
  const form = useForm({
    initialValues: {
      siteCode: undefined, // 금형 명 (같은 이름이면 같은 금형이다.)
      code: name, // 금형코드
      capacity: undefined, // 금형 용량
    },
  });

  return (
    <Box maw={320} mx="auto">
      <form onSubmit={form.onSubmit((values) => onSubmit && onSubmit(values))}>
        <TextInput
          label="code"
          placeholder="코드"
          {...form.getInputProps("code")}
        />
        <SitesAutoComplete
          label="site"
          width="100%"
          placeholder="사업장"
          {...form.getInputProps("siteCode")}
        />
        <TextInput
          label="금형용량"
          placeholder="금형용량"
          {...form.getInputProps("capacity")}
        />
        <Text size="sm" weight={500} mt="xl">
          Form values:
        </Text>
        <Code block mt={5}>
          {JSON.stringify(form.values, null, 2)}
        </Code>
        <Button type="submit">Submit</Button>
      </form>
    </Box>
  );
}
